var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTrivago = function SvgTrivago(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 50,
    viewBox: "0 0 64 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.947 1.12305H40.052V49.018H23.947V1.12305Z",
    fill: "#F48F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.965 49.017H7.422C7.422 49.017 0 49.158 0 40.755V0.842041H16.105L15.965 49.017Z",
    fill: "#007FAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.035 0.983059H56.578C56.578 0.983059 64 0.84206 64 9.24506V49.1571H48.035V0.983059Z",
    fill: "#C94A38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 50,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrivago, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trivago.ed515151.svg";
export { ForwardRef as ReactComponent };